export const SET_FEATURES = 'SET_FEATURES';

export const _setFeatures = (features) => {
  return {
    type: SET_FEATURES,
    payload: features,
  };
};
